import script from "./TokenPrices.vue?vue&type=script&lang=ts&setup=true"
export * from "./TokenPrices.vue?vue&type=script&lang=ts&setup=true"

import "./TokenPrices.vue?vue&type=style&index=0&id=46f90239&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46f90239"]])

export default __exports__